module.exports = {
      id: "premium-usage",
      viewBox: "0 0 576 512",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#premium",
      toString: function () {
        return this.url;
      }
    }